import React, { PureComponent, Fragment } from 'react';
import menuData from './headermenu.json';

import { Link } from 'formlabs-web-components/Link';
import { Header } from 'formlabs-web-components/Type';
import { GridContainer } from 'formlabs-web-components/Grid';
import { InteractiveDiv } from 'formlabs-web-components/Wrapper';

import logo from '../../../../public/logo_white.svg';

import '../../../common/components/navigation/HeaderMenu.module.css';

export default class CareersHeader extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      mobile: false,
      open: false,
      Locations: false,
      'Our Teams': false
    };
    this.toggleMenu = this.toggleMenu.bind(this);
  }
  renderTree(root) {
    const scope = this;
    if (root.children) {
      if (!this.state[root.data.name]) {
        this.setState({ [root.data.name]: false });
      }
      return (
        <Fragment>
          <Link
            to={root.data.url}
            styleName="link"
            onClickCapture={e => scope.accordion(e, root.data.name)}
          >
            {root.data.name}
          </Link>
          <ul
            styleName={`submenu ${
              this.state[root.data.name] ? 'submenu-opened' : ''
            }`}
          >
            {root.children.map(c => (
              <li key={c.id} styleName="submenuli">
                {this.renderTree(c)}
              </li>
            ))}
          </ul>
        </Fragment>
      );
    } else {
      return (
        <Link to={root.data.url} onClick={scope.toggleMenu}>
          {root.data.name}
        </Link>
      );
    }
  }
  accordion(event, name) {
    if (this.state.mobile) {
      event.preventDefault();
      event.stopPropagation();
      this.setState({ [name]: !this.state[name] });
    }
  }
  toggleMenu() {
    if (this.state.mobile) {
      if (this.state.open) {
        document.documentElement.style.cssText =
          "overflow: visible; position: ''; height: '';";
        document.body.style.cssText =
          "overflow: visible; position: ''; height: '';";
      } else {
        document.documentElement.style.cssText =
          'overflow: hidden; position: relative; height: 100%;';
        document.body.style.cssText =
          'overflow: hidden; position: relative; height: 100%;';
      }
      this.setState({ open: !this.state.open });
    }
  }

  componentDidMount() {
    window.addEventListener('resize', this.resize.bind(this));
    this.resize();
  }

  resize() {
    this.setState({ mobile: window.innerWidth <= 950 });
  }

  render() {
    const scope = this;
    return (
      <div styleName="secondary-header">
        {this.state.mobile && (
          <GridContainer>
            <div className="has-container" styleName="closed-menu">
              <Link to="/">
                <div>
                  <div styleName="logo-container">
                    <img src={logo} alt="Formlabs" />
                  </div>
                  <Header
                    level={5}
                    displayAs={5}
                    styles={{
                      display: 'inline-block',
                      color: '#fff',
                      fontSize: '1.05rem'
                    }}
                  >
                    Careers
                  </Header>
                </div>
              </Link>
              <InteractiveDiv
                styleName={`hamburger ${this.state.open ? 'open' : ''} ${
                  !this.state.open ? 'white-nav' : 'black-nav'
                }`}
                handler={this.toggleMenu}
                aria-label={'mobile menu toggle'}
              >
                <span />
                <span />
                <span />
                <span />
              </InteractiveDiv>
            </div>
          </GridContainer>
        )}
        <div
          styleName={`actual-menu open-${this.state.open}`}
          style={{
            overflow: this.state.mobile ? 'auto' : 'visible',
            height: '100%',
            paddingBottom: this.state.mobile ? '80px' : ''
          }}
        >
          <GridContainer>
            <div className="has-container">
              <div styleName="careers-header">
                <span styleName="careers-home">
                  <Link to="/" onClick={this.toggleMenu}>
                    <div styleName="logo-container">
                      <img src={logo} alt="Formlabs" />
                    </div>
                    <Header level={5} displayAs={5}>
                      Careers
                    </Header>
                  </Link>
                </span>
                <ul styleName="menu">
                  {menuData.map(function(item, i) {
                    if (item.children) {
                      return (
                        <li key={i} styleName={`menuli has-children`}>
                          {scope.renderTree(item)}
                        </li>
                      );
                    } else {
                      return (
                        <li key={i} styleName="menuli">
                          {scope.renderTree(item)}
                        </li>
                      );
                    }
                  })}
                </ul>
              </div>
            </div>
          </GridContainer>
        </div>
      </div>
    );
  }
}

CareersHeader.propTypes = {};
